import { createAction, props } from '@ngrx/store';
import { DocumentItem } from '@klubovna/shared-models';

export const loadDocuments = createAction('[Documents] Load Documents');
export const loadDocumentsSuccess = createAction(
  '[Documents] Load Documents Success',
  props<{ documents: DocumentItem[] }>(),
);
export const loadDocumentsFailure = createAction('[Documents] Load Documents Failure', props<{ error: string }>());
